/* eslint-disable indent */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router';
import {
  Menu,
  Icon,
  Divider,
  Segment,
  Label,
  Grid,
  Header,
  Button,
  Image,
  Container,
} from 'semantic-ui-react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { filter } from 'graphql-anywhere';
import { isEqual } from 'lodash';

import Modal from '../../../../components/Modal';
import Avatar from '../../../../components/Avatar';
import FeaturesModal from '../../../../components/FeaturesModal';

import ElementModifier from '../../../../components/ElementModifier';
import Responsive from '../../../../components/Responsive';
import ReviewStatusTooltip from '../../../../components/ui/ReviewStatusTooltip';

import MessageSurveyResults from '../../ui/MessageSurveyResults';

import MessageFiles from '../../Files';

import { MessageReportResults } from '../../ui/MessageReportResults';
import MessageCharges from '../../Charges';
import MessageCommitmentReminds from '../../CommitmentReminds';
import EntityItem from '../../../Entity/Item';
import MessageFormResults from '../../FormResults';
import onClose from '../../utils/onClose';
import MessageStatus from './MessageStatus';

import MessageLabel from './MessageLabel';

import * as utils from '../../../../utils';
import { __ } from '../../../../i18n';
import { getChargesFromInput } from '../../Edit/utils/getChargesFromInput';
import { MessageMedias } from '../../ui/MessageMedias';
import { getDetailMediasFromInput } from '../../utils/getDetailMediasFromInput';
import { getDetailCommitmentsFromInput } from '../../utils/getDetailCommitmentsFromInput';
import { getReportsFromHelpers } from '../../Edit/utils/getReportsFromHelpers';
import { filterEntitiesWithResultsInReportData } from '../../Edit/utils/filterEntitiesWithResultsInReportData';
import { getFormsFromHelpers } from '../../Edit/utils/getFormsFromHelpers';
import { getSurveysFromInput } from '../../Edit/utils/getSurveysFromInput';

const styles = {
  moreRecipients: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: '32px',
    height: '32px',
    backgroundColor: '#9696a0',
    color: '#fff',
    fontWeight: 'bold',
    borderRadius: '4em',
    border: 'solid 2px #ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

/**
 * @typedef {{
 *  id: number,
 *  subject: string,
 *  content: string,
 *  summary: string,
 *  public: number,
 *  created?: string,
 *  modified?: string,
 *  recipientsCount: number,
 *  deleted?: string,
 *  fwMessageId: number,
 *  entity: {
 *    id: number,
 *    type: 'ADMIN' | 'STAFF' | 'STUDENT',
 *    isChannel: boolean,
 *    roles: {
 *     nodes: {
 *      id: number,
 *      name: string
 *     },
 *    },
 *    organizationId: number,
 *    fullname: string,
 *    shortname: string,
 *    seeAll: boolean,
 *    code: number,
 *    disabled: boolean,
 *    picture: {
 *    id: number,
 *   },
 *   organization: {
 *    id: number,
 *    type: string,
 *   },
 *  },
 *  user: {
 *    id: number,
 *    fullname: string,
 * }
 * }} MessageNodeEntityQuery
 */

@inject('store', 'client')
@graphql(
  gql`
    query MessageNodeEntityQuery($entityId: ID!, $messageId: ID!) {
      node(id: $entityId) {
        ... on Entity {
          id: dbId
          messageToApprove(id: $messageId) {
            id
            subject
            content
            summary
            public
            input
            label {
              id
              title
              color
              modified
              created
            }
            helpers
            created
            modified
            recipientsCount
            sendAt
            deleted
            fwMessageId
            entity {
              id: dbId
              type
              isChannel
              roles {
                nodes {
                  id: dbId
                  name
                }
              }
              organizationId
              fullname
              shortname
              seeAll
              code
              disabled
              picture {
                id
              }
              organization {
                id
                type
              }
            }
            toEntity {
              id
              isChannel
              status
              organizationId
              id
              fullname
              shortname
              seeAll
              code
              disabled
              type
              picture {
                id
              }
              organization {
                id
                type
              }
            }
            user {
              id: dbId
              fullname
            }
          }
        }
      }
    }
  `,
  {
    options: (ownProps) => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      variables: {
        entityId: ownProps.params.entity_id,
        messageId: ownProps.params.message_id,
      },
    }),
    skip: (ownProps) => !ownProps.params.entity_id,
  },
)
@observer
class MessageApproveModal extends Responsive {
  constructor(props) {
    super(props);

    this.state = {
      information: false,
    };
  }

  verifyNode = (nextProps) => {
    return (
      !nextProps.data.node &&
      this.props.data.node &&
      isEqual(this.props.data.variables, nextProps.data.variables)
    );
  };

  /**
   * TEMPORARY FIX: Este método corrige um bug conhecido do Apollo Client (walle#3219)
   * onde o data.node desaparece durante re-renders mesmo quando a
   * query foi bem-sucedida no network. Como o componentWillReceiveProps está
   * deprecated, este é um workaround que corrige o bug sem necessitar realizar diversos
   * refetches.
   *
   * @deprecated Este método será removido no React 17. Migrar para componentDidUpdate.
   */
  componentWillReceiveProps(nextProps) {
    if (this.verifyNode(nextProps)) {
      nextProps.data.node = this.props.data.node;
    }
  }

  shouldComponentUpdate(nextProps) {
    // fix for apollo bug, node disappears.. walle#3219
    return !this.verifyNode(nextProps);
  }

  handleOnClose = () => {
    const { store, router } = this.props;

    if (store.history.length > 1) {
      router.goBack();
    } else {
      const link = store.previous.params.entity_id
        ? `/entities/${store.previous.params.entity_id}/messages`
        : '/';

      router.push(link);
    }
  };

  backAndRefresh = () => {
    const { store, router, location } = this.props;

    if (store.history.length > 1) {
      router.goBack();
    } else {
      let link = '';
      if (store.previous.params.entity_id) {
        if (location.search)
          link = `/entities/${store.previous.params.entity_id}/messages${location.search}`;
        else link = `/entities/${store.previous.params.entity_id}/messages`;
      } else if (store.previous.params.organization_id)
        link = `/organizations/${store.previous.params.organization_id}/messages`;
      else link = '/';
      router.push(link);
    }
  };

  openPaywall() {
    this.props.store.appends.push(<FeaturesModal feature="DELETE_MESSAGE" />);
  }

  render() {
    const { data, params, store } = this.props;
    const { information, loading } = this.state;
    const { app } = store;

    if (
      !params.organization_id &&
      ((data &&
        data.node &&
        data.node.messageToApprove &&
        data.node.messageToApprove.deleted) ||
        (data &&
          data.error &&
          data.error.message ===
            // eslint-disable-next-line quotes
            "GraphQL error: Can't access deleted messages"))
    ) {
      return (
        <Modal size="small" closeOnRootNodeClick={false}>
          <Modal.Content
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '4px',
              boxShadow: '0 1px 0 0 #dededf',
            }}
          >
            <Container textAlign="center">
              <Image
                src={utils.asset('/images/deletedMessage.png')}
                style={{
                  width: '300px',
                  height: '300px',
                  margin: 'auto',
                  marginTop: '48px',
                }}
              />
              <div style={{ display: 'grid', marginTop: '24px' }}>
                <span
                  style={{
                    fontSize: '18px',
                    fontWeight: '500',
                    color: '#212529',
                  }}
                >
                  {__('Unavailable Message')}
                </span>
                <span
                  style={{
                    fontSize: '14px',
                    color: '#868e96',
                    marginBottom: '48px',
                    marginTop: '8px',
                  }}
                >
                  {__(
                    'This message has been deleted and can no longer be viewed!',
                  )}
                </span>
              </div>
            </Container>
          </Modal.Content>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              data-action="goBack"
              style={{
                color: '#666666',
                margin: '14px',
                backgroundColor: 'white',
                border: '.5px solid rgba(102, 102, 102, 0.3)',
              }}
              key={1}
              primary
              content={__('Close')}
              onClick={() => {
                this.setState({ onLeave: true }, () => {
                  this.backAndRefresh();
                });
              }}
            />
          </div>
        </Modal>
      );
    }
    if (data.error) {
      return (
        <Modal
          header={__('Error')}
          content={__('An error has occurred.')}
          actions={[
            <Button
              data-action="cancel"
              key={1}
              primary
              content={__('OK')}
              onClick={() => {
                this.setState({ onLeave: true }, () => {
                  this.props.router.goBack();
                });
              }}
            />,
          ]}
        />
      );
    }
    if ((data.loading && !data.node) || !data.node || loading) {
      return <Modal loading />;
    }

    const { type, organizationId, disabled, messageToApprove } = data.node;
    const messageToApproveInput = JSON.parse(messageToApprove.input);
    const charges = getChargesFromInput(messageToApprove?.input);
    const medias = getDetailMediasFromInput(
      messageToApprove?.input,
      store?.app?.env,
    );
    const messageType = 'SENT';
    const commitments = getDetailCommitmentsFromInput(messageToApprove?.input);
    const forms = getFormsFromHelpers(messageToApprove?.helpers);
    const surveys = getSurveysFromInput(messageToApprove.input);

    const reports = filterEntitiesWithResultsInReportData(
      getReportsFromHelpers(messageToApprove.helpers),
    );

    const entityLink = (e) =>
      (store.currentUser.isMaster ||
        (type === 'ADMIN' &&
          organizationId === messageToApprove.entity.organizationId)) &&
      e.organizationId
        ? `/organizations/${e.organizationId}/${e.isChannel ? 'channels' : 'entities'}?search=${e.fullname}`
        : null;

    return (
      <Modal
        id="MessageNode"
        open
        size="small"
        closeIcon="times close inside"
        onClose={() => onClose(false, store, this.handleOnClose, null, null)}
        closeOnRootNodeClick={false}
        key={messageToApprove.id}
      >
        <Modal.Header style={{ padding: '0.5em' }}>
          <Menu compact secondary />
        </Modal.Header>
        <Modal.Content style={{ paddingBottom: 24 }}>
          <Segment.Group style={{ margin: 0 }}>
            <Segment secondary>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column
                    width={13}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    {messageToApprove.recipientsCount === 1 ? (
                      <span
                        className="thirteen wide column"
                        style={{ display: 'flex' }}
                      >
                        {messageToApprove.toEntity && (
                          <EntityItem
                            to={entityLink(messageToApprove.toEntity)}
                            entity={filter(
                              EntityItem.fragments.entity,
                              messageToApprove.toEntity,
                            )}
                            fromMessage
                          />
                        )}
                      </span>
                    ) : (
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          position: 'relative',
                          marginBottom: 3,
                        }}
                      >
                        <Avatar
                          avatar
                          src={
                            messageToApprove.toEntity &&
                            messageToApprove.toEntity.picture &&
                            messageToApprove.toEntity.picture.uri
                          }
                          alt={
                            messageToApprove.toEntity &&
                            messageToApprove.toEntity.fullname
                          }
                          style={
                            messageToApprove.deleted
                              ? messageToApprove.recipientsCount > 1
                                ? {
                                    width: '32px',
                                    height: '32px',
                                    opacity: 0.65,
                                  }
                                : {
                                    width: '40px',
                                    height: '40px',
                                    opacity: 0.65,
                                  }
                              : messageToApprove.recipientsCount > 1
                                ? { width: '32px', height: '32px' }
                                : { width: '40px', height: '40px' }
                          }
                        />
                        {messageToApprove.recipientsCount > 1 ? (
                          <div style={styles.moreRecipients}>
                            +{messageToApprove.recipientsCount - 1}
                          </div>
                        ) : null}
                      </div>
                    )}
                    <div
                      style={{ display: 'inline-block', marginLeft: '10px' }}
                    >
                      <div>
                        {messageToApprove.recipientsCount === 1 ? (
                          <span
                            style={{ display: 'flex', alignItems: 'baseline' }}
                          >
                            <span>{__('to')}</span>
                            {messageToApprove.toEntity &&
                              (entityLink(messageToApprove.toEntity) ? (
                                <Link
                                  to={entityLink(messageToApprove.toEntity)}
                                  style={{
                                    color: '#007fff',
                                    fontWeight: 500,
                                    fontSize: '16px',
                                    paddingLeft: '5px',
                                  }}
                                >
                                  {messageToApprove.toEntity.fullname}
                                </Link>
                              ) : (
                                <span
                                  style={{
                                    fontWeight: 500,
                                    fontSize: '16px',
                                    paddingLeft: '5px',
                                  }}
                                >
                                  {messageToApprove.toEntity.fullname}
                                </span>
                              ))}
                          </span>
                        ) : (
                          <span
                            style={{ display: 'flex', alignItems: 'baseline' }}
                          >
                            <span>{__('to')}</span>
                            <Link
                              style={{
                                color: 'rgba(0,0,0,.6)',
                                fontWeight: 500,
                                fontSize: '16px',
                                paddingLeft: '5px',
                              }}
                            >
                              {messageToApprove.recipientsCount.toString() +
                                ' ' +
                                __('recipients')}
                            </Link>
                          </span>
                        )}
                      </div>
                      <div
                        style={{
                          whiteSpace: 'nowrap',
                          color: '#9696a0',
                          fontSize: '12px',
                        }}
                      >
                        <span>
                          {utils.simpleDate(
                            messageToApprove.modified,
                            true,
                            'LLL',
                            app.locale,
                          )}
                        </span>
                        {!this.isMobile() && (
                          <MessageStatus
                            message={messageToApprove}
                            isMobile={this.isMobile()}
                          />
                        )}
                      </div>

                      {this.isMobile() && (
                        <div
                          style={{
                            whiteSpace: 'nowrap',
                            color: '#9696a0',
                            fontSize: '12px',
                          }}
                        >
                          <MessageStatus
                            message={messageToApprove}
                            isMobile={this.isMobile()}
                          />
                        </div>
                      )}
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    data-action="toggle-information"
                    textAlign="right"
                    width={3}
                    onClick={() => this.setState({ information: !information })}
                  />
                </Grid.Row>
                {information &&
                  messageToApprove.entity.type === 'STUDENT' &&
                  messageToApprove.entity.roles.nodes.length > 0 && (
                    <Grid.Row>
                      <Grid.Column>
                        <Icon name="graduation cap" />
                        {messageToApprove.entity.roles.nodes.map(
                          (role, key) => (
                            <Label basic key={key}>
                              {role.name.length > 36
                                ? role.name.substring(0, 36) + '...'
                                : role.name}
                            </Label>
                          ),
                        )}
                      </Grid.Column>
                    </Grid.Row>
                  )}
              </Grid>
            </Segment>
            {messageToApprove.sendAt && (
              <Segment className="tooltip-segment">
                <ReviewStatusTooltip
                  date={utils.simpleDate(
                    messageToApprove.sendAt,
                    true,
                    'DD MMM, HH:mm',
                    app.locale,
                  )}
                  status="sendLater"
                />
              </Segment>
            )}
            <Segment className="wordWrapped">
              {(!!messageToApproveInput.subject ||
                !!messageToApprove.label) && (
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  {messageToApproveInput.subject ? (
                    <Header>{messageToApproveInput.subject}</Header>
                  ) : (
                    <div />
                  )}
                  <MessageLabel label={messageToApprove.label} />
                </div>
              )}
              {!!messageToApproveInput.content && (
                <div
                  className="content clsp-content ql-editor"
                  dangerouslySetInnerHTML={{
                    __html: messageToApproveInput.content,
                  }}
                />
              )}
              <Divider hidden />
              <MessageMedias
                images={medias.images}
                videos={medias.videos}
                audios={medias.audios}
              />
              <MessageFiles files={medias.files} />
              <MessageCommitmentReminds
                params={params}
                messageType={messageType}
                entity={{ disabled }}
                fromHistory
                isMessageToApprove
                commitments={commitments}
              />
              <MessageReportResults
                params={params}
                messageType={messageType}
                reports={reports}
              />
              <MessageSurveyResults
                surveys={surveys}
                params={params}
                entity={{ disabled }}
              />
              <MessageCharges
                charges={charges}
                params={params}
                reload={() => this.reload()}
                messageType={messageToApprove.entity.type}
                entity={messageToApprove.entity}
                messageToApprove={messageToApprove}
              />
              <MessageFormResults
                params={params}
                messageType={messageToApprove.entity.type}
                entity={messageToApprove.entity}
                forms={forms}
                messageToApprove={messageToApprove}
              />
            </Segment>
          </Segment.Group>
          {this.props.children &&
            React.cloneElement(this.props.children, {
              super: this.props.super,
            })}
          {!this.isMobile() && (
            <ElementModifier
              element={document.body}
              newClassName="paddingOnModalDimmer"
            />
          )}
        </Modal.Content>
      </Modal>
    );
  }
}

export default MessageApproveModal;
